/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getApiProfileCvSummary200Schema = z.object({
  hasOriginal: z.boolean(),
  hasPdfPreview: z.boolean(),
  fileName: z.coerce.string().nullable().nullish(),
  contentType: z.coerce.string().nullable().nullish(),
  fileExtension: z.coerce.string().nullable().nullish(),
  fileSizeBytes: z.coerce.number().int().nullable().nullish(),
  uploadedAt: z.string().datetime({ local: true }).nullable().nullish(),
  updatedAt: z.string().datetime({ local: true }).nullable().nullish(),
  cvUpdateRequested: z.boolean(),
  cvUpdateRequestedAt: z
    .string()
    .datetime({ local: true })
    .nullable()
    .nullish(),
  cvLastUpdatedAt: z.string().datetime({ local: true }).nullable().nullish(),
});

export const getApiProfileCvSummaryQueryResponseSchema = z.lazy(
  () => getApiProfileCvSummary200Schema,
);
